import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {NgClass, NgIf} from "@angular/common";

@Component({
    selector: 'app-wrench-bottom-sheet-footer',
    templateUrl: './wrench-bottom-sheet-footer.component.html',
    standalone: true,
    imports: [
        MatButtonModule,
        FontAwesomeModule,
        NgClass,
        NgIf
    ],
    styleUrls: ['./wrench-bottom-sheet-footer.component.scss']
})
export class WrenchBottomSheetFooterComponent implements OnInit {

    @Input() secondaryButtonText: string;
    @Input() primaryButtonText: string;
    @Input() primaryButtonDisabled: Function | boolean;
    @Output() secondaryButtonClick = new EventEmitter();
    @Output() primaryButtonClick = new EventEmitter();

    constructor() {}

    ngOnInit(): void {
    }

    isPrimaryButtonDisabled(): boolean {
        if (this.primaryButtonDisabled instanceof Function) {
            return this.primaryButtonDisabled();
        } else {
            return this.primaryButtonDisabled;
        }
    } // isPrimaryButtonDisabled()
}
